import React, { FC } from 'react';
import { ChevronDown } from 'lucide-react';

interface FAQItem {
    question: string;
    answer: string;
}

interface PostFAQProps {
    faqList: FAQItem[];
}

const PostFAQ: FC<PostFAQProps> = ({ faqList }) => {
    if (!faqList || faqList.length === 0) {
        return null;
    }

    return (
        <section className='mb-5 mt-10'>
            <h2 className='text-xl font-bold mb-4 text-[#364153] dark:text-gray-200 customBorder'>
                سوالات متداول
            </h2>
            <div className='flex flex-col gap-2'>
                {faqList.map((faq, index) => (
                    <details
                        key={index}
                        className='group rounded-xl bg-gray-100 dark:bg-white/5 px-3 py-2 border border-gray-200 dark:border-white/10 transition-all'
                    >
                        <summary className='cursor-pointer flex justify-between py-2 items-center text-sm max-lg:text-xs font-medium text-right list-none'>
                            {faq.question}
                            <ChevronDown
                                size={15}
                                className='transition-transform group-open:rotate-180 stroke-dark/70'
                            />
                        </summary>
                        <div className='mt-2 text-xs border-t border-black/10 dark:border-white/10 pt-4 font-light text-justify leading-relaxed'>
                            {faq.answer}
                        </div>
                    </details>
                ))}
            </div>
        </section>
    );
};

export default PostFAQ;
